import JobsiteMultiSearch from '../CustomCode/FwContracts/JobsiteMultiSearch'
import JobsiteMultiSearchForm from '../CustomCode/FwContracts/JobsiteMultiSearchForm'
import OSRJobsiteReport from '../CustomCode/FwContracts/OSRJobsiteReport'
import LetterSearchForm from '../CustomCode/FwContracts/LetterSearchForm'
import LetterSearch from '../CustomCode/FwContracts/LetterSearch'
import CrossEntityReport from '../CustomCode/CrossEntityReport'
import CrossEntityReportForm from '../CustomCode/CrossEntityReportForm'
import OSRReportForm from '../CustomCode/FwContracts/OSRReportForm'
import OSRReport from '../CustomCode/FwContracts/OSRReport'
import CalendarReport from '../CustomCode/TKCal/CalendarReport'
import EmailReport from '../CustomCode/TKCal/EmailReport'
import NewCalendarReportForm from '../CustomCode/TKCal/NewCalendarReportForm'
import DeadlineReport from '../CustomCode/TKCal/DeadlineReport'
import PlaintiffSearchForm from '../CustomCode/FwInvoice/PlaintiffSearchForm'
import PlaintiffSearch from '../CustomCode/FwInvoice/PlaintiffSearch'
import ExclusionProcedure from '../CustomCode/BosSci/ExclusionProcedure'
import ExclusionStatus from '../CustomCode/BosSci/ExclusionStatus'
import CalendarActivityReport from '../CustomCode/TKCal/CalendarActivityReport'
import CalendarActivityReportForm from '../CustomCode/TKCal/CalendarActivityReportForm'
import CopyLink from '../CustomCode/TKCal/CopyLink'
import EmailTimekeeperReport from '../CustomCode/ItProjects/EmailTimekeeperReport'
import UploadTimekeeperFile from '../CustomCode/ItProjects/UploadTimekeeperFile'
import ServiceRider from '../CustomCode/NJAsbestos/ServiceRider'
import UploadCurrencyFile from '../CustomCode/Woodcosts/UploadCurrencyFile'
import CrossEntityObject from '../CustomCode/NJAsbestos/CrossEntityObject'
import CaseManagementReport from '../CustomCode/HBFuller/CaseManagementReport'
import CaseManagementReportForm from '../CustomCode/HBFuller/CaseManagementReportForm'
import HistoricalClaimActivityReport from '../CustomCode/HBFuller/HistoricalClaimActivityReport'
import HistoricalClaimActivityReportForm from '../CustomCode/HBFuller/HistoricalClaimActivityReportForm'
import SingleFieldSearch from '../CustomCode/SingleFieldSearch'
import SingleFieldSearchForm from '../CustomCode/SingleFieldSearchForm'
import UploadLedesFile from '../CustomCode/FwInvoice/UploadLedesFile'
import CaseSearch from '../CustomCode/BosSci/CaseSearch'
import CaseSearchForm from '../CustomCode/BosSci/CaseSearchForm'
import ActiveCasesPDF from '../CustomCode/CatEast/ActiveCasesPDF'
import RetrievexForm from '../CustomCode/BridgeportDepository/RetrievexForm'
import RetrievexReport from '../CustomCode/BridgeportDepository/RetrievexReport'
import MasterCaseList from '../CustomCode/CatEast/MasterCaseList'
import QuarterlyAuditReportForm from '../CustomCode/BosSci/QuarterlyAuditReportForm'
import QuarterlyAuditReport from '../CustomCode/BosSci/QuarterlyAuditReport'
import CaseCourtSurgeryReportForm from '../CustomCode/BosSci/CaseCourtSurgeryReportForm'
import CaseCourtSurgeryReport from '../CustomCode/BosSci/CaseCourtSurgeryReport'
import PaidDefenseIndemnityFeesForm from '../CustomCode/Asbestos/PaidDefenseIndemnityFeesForm'
import PaidDefenseIndemnityFees from '../CustomCode/Asbestos/PaidDefenseIndemnityFees'
import PaidIndemnityForm from '../CustomCode/Asbestos/PaidIndemnityForm'
import PaidIndemnity from '../CustomCode/Asbestos/PaidIndemnity'
import AuditReportForm from '../CustomCode/Asbestos/AuditReportForm'
import AuditReport from '../CustomCode/Asbestos/AuditReport'
import AuditReportPdf from '../CustomCode/Asbestos/AuditReportPdf'
import PeriodBasedReportForm from '../CustomCode/Asbestos/PeriodBasedReportForm'
import PeriodBasedReport from '../CustomCode/Asbestos/PeriodBasedReport'
import PeriodBasedDetails from '../CustomCode/Asbestos/PeriodBasedDetails'
import LibertyMutualDefenseFeesForm from '../CustomCode/Asbestos/LibertyMutualDefenseFeesForm'
import LibertyMutualDefenseFees from '../CustomCode/Asbestos/LibertyMutualDefenseFees'
import AIGReportForm from '../CustomCode/Asbestos/AIGReportForm'
import AIGReport from '../CustomCode/Asbestos/AIGReport'
import TrialDateForm from '../CustomCode/Asbestos/TrialDateForm'
import TrialDateReport from '../CustomCode/Asbestos/TrialDateReport'
import TrialCalendarForm from '../CustomCode/Asbestos/TrialCalendarForm'
import TrialCalendarReport from '../CustomCode/Asbestos/TrialCalendarReport'
import LossSettlementForm from '../CustomCode/Asbestos/LossSettlementForm'
import LossSettlementReport from '../CustomCode/Asbestos/LossSettlementReport'
import DuplicateSSNReport from '../CustomCode/Asbestos/DuplicateSSNReport'
import ClaimCountsTodayForm from '../CustomCode/Asbestos/ClaimCountsTodayForm'
import ClaimCountsTodayReport from '../CustomCode/Asbestos/ClaimCountsTodayReport'
import DamagesSoughtForm from '../CustomCode/Asbestos/DamagesSoughtForm'
import DamagesSoughtReport from '../CustomCode/Asbestos/DamagesSoughtReport'
import WorkHistoryUpdate from '../CustomCode/Asbestos/WorkHistoryUpdate'
import PlaintiffFirmReportForm from '../CustomCode/BosSci/PlaintiffFirmReportForm'
import PlaintiffFirmReport from '../CustomCode/BosSci/PlaintiffFirmReport'
import DuplicatePlaintiffReportForm from '../CustomCode/BosSci/DuplicatePlaintiffReportForm'
import DuplicatePlaintiffReport from '../CustomCode/BosSci/DuplicatePlaintiffReport'
import ProductSurgeryReportForm from '../CustomCode/BosSci/ProductSurgeryReportForm'
import ProductSurgeryReport from '../CustomCode/BosSci/ProductSurgeryReport'
import AsbestosCalendarActivityReport from '../CustomCode/Asbestos/CalendarActivityReport'
import AsbestosCalendarActivityReportForm from '../CustomCode/Asbestos/CalendarActivityReportForm'
import ReopenedClaimsReportForm from '../CustomCode/Asbestos/ReopenedClaimsReportForm'
import ReopenedClaimsReport from '../CustomCode/Asbestos/ReopenedClaimsReport'
import LossSettlementFundingRequestForm from '../CustomCode/Asbestos/LossSettlementFundingRequestForm'
import WorkHistoryReportForm from '../CustomCode/Asbestos/WorkHistoryReportForm'
import LogReportForm from '../CustomCode/Asbestos/LogReportForm'
import ValuationProjectionForm from '../CustomCode/BosSci/ValuationProjectionForm'
import OpenClaimsByAttorneyPDF from '../CustomCode/BISC/OpenClaimsByAttorneyPDF'
import BordereauxReportPDF from '../CustomCode/BISC/BordereauxReportPDF'
import LossSettlementFundingRequestReport from '../CustomCode/Asbestos/LossSettlementFundingRequestReport'
import ValuationProjectionReport from '../CustomCode/BosSci/ValuationProjectionReport'
import CaseCountWeekReport from '../CustomCode/BosSci/CaseCountWeekReport'
import CaseCountWeekDetails from '../CustomCode/BosSci/CaseCountWeekDetails'
import ClaimCountsByStateForm from '../CustomCode/Asbestos/ClaimCountsByStateForm'
import ClaimCountsByDiseaseForm from '../CustomCode/Asbestos/ClaimCountsByDiseaseForm'
import ExclusionCountChangesReport from '../CustomCode/BosSci/ExclusionCountChangesReport'
import LogReport from '../CustomCode/Asbestos/LogReport'
import WorkHistoryReport from '../CustomCode/Asbestos/WorkHistoryReport'
import PlaintiffUpdateForm from '../CustomCode/Asbestos/PlaintiffUpdateForm'
import PlaintiffUpdate from '../CustomCode/Asbestos/PlaintiffUpdate'
import BordereauxReportDetails from '../CustomCode/BISC/BordereauxReportDetails'
import ClaimCountsByReport from '../CustomCode/Asbestos/ClaimCountsByReport'
import RiskSummaryReport from '../CustomCode/Asbestos/RiskSummaryReport'
import AverageDefenseCostForm from '../CustomCode/Asbestos/AverageDefenseCostForm'
import AverageDefenseCost from '../CustomCode/Asbestos/AverageDefenseCost'
import PlaintiffDefenseFeeForm from '../CustomCode/Asbestos/PlaintiffDefenseFeeForm'
import PlaintiffDefenseFeeReport from '../CustomCode/Asbestos/PlaintiffDefenseFeeReport'
import ListInvoices from '../CustomCode/Asbestos/ListInvoices'
import InvoiceDetailReport from '../CustomCode/Asbestos/InvoiceDetailReport'
import InvoiceDetailForm from '../CustomCode/Asbestos/InvoiceDetailForm'
import MonthlyCountReport from '../CustomCode/BosSci/MonthlyCountReport'
import MonthlyCountForm from '../CustomCode/BosSci/MonthlyCountForm'
import DepositionReportForm from '../CustomCode/NJAsbestos/DepositionReportForm'
import DepositionReport from '../CustomCode/NJAsbestos/DepositionReport'
import DataQualityReport from '../CustomCode/BosSci/DataQualityReport'
import DataQualityDetail from '../CustomCode/BosSci/DataQualityDetail'
import QuarterlySummaryReport from '../CustomCode/HBFuller/QuarterlySummaryReport'
import PendingByReport from '../CustomCode/HBFuller/PendingByReport'
import ValuationProjectionByCategory from '../CustomCode/BosSci/ValuationProjectionByCategory'
import Workflow from '../CustomCode/Workflow'
import CircularReferences from '../CustomCode/BosSci/CircularReferences'
import TicklerReport from '../CustomCode/AAG/TicklerReport'
import AAGPlaintiffUpdateForm from '../CustomCode/AAG/PlaintiffUpdateForm'
import AAGPlaintiffUpdate from '../CustomCode/AAG/PlaintiffUpdate'
import PlaintiffReportForm from '../CustomCode/AAG/PlaintiffReportForm'
import PlaintiffReport from '../CustomCode/AAG/PlaintiffReport'
import PicklistForm from '../Picklist/PicklistForm'
import PicklistResults from '../Picklist/PicklistResults'
import ActivityLogRoute from '../ActivityLog/ActivityLogRoute'
import ClaimFileReport from '../CustomCode/Asbestos/ClaimFileReport'
import ClaimFileForm from '../CustomCode/Asbestos/ClaimFileForm'
import CostReportForm from '../CustomCode/Woodcosts/CostReportForm'
import CostReport from '../CustomCode/Woodcosts/CostReport'
import MedicareReportForm from '../CustomCode/Asbestos/MedicareReportForm'
import MedicareReport from '../CustomCode/Asbestos/MedicareReport'
import LossSettlementFundingRequestPDF from '../CustomCode/Asbestos/LossSettlementFundingRequestPDF'
import MedicareNewForm from '../CustomCode/Asbestos/MedicareNewForm'
import MedicareNew from '../CustomCode/Asbestos/MedicareNew'
import BilledHoursReportForm from '../CustomCode/ItProjects/BilledHoursReportForm'
import BilledHoursReport from '../CustomCode/ItProjects/BilledHoursReport'
import ShowSignUpLink from '../SignUp/ShowSignUpLink'
import LibertyMutual2024Form from '../CustomCode/Asbestos/LibertyMutual2024Form'
import LibertyMutual2024 from '../CustomCode/Asbestos/LibertyMutual2024'

export default function CustomRoute({ match, location }) {
  console.log('CustomRoute rendered', match, location)

  let procedure = null
  if (match) {
    if (match && match.params.procedure) {
      procedure = match.params.procedure

      if (procedure.indexOf('njcal.deadline_report') > -1) {
        return <DeadlineReport location={location} />
      }
      if (procedure.indexOf('njcal.web_email_calendar_report') > -1) {
        return <EmailReport reportCode="CALENDAR" location={location} />
      }
      if (procedure.indexOf('fwcontracts.cross_entity_search') > -1) {
        if (location.search && location.search !== '?in_doc_type=963984') {
          return <CrossEntityReport location={location} />
        }
        return <CrossEntityReportForm location={location} />
      }
      console.log('procedure: ', procedure)
      switch (procedure) {
        case 'fwcontracts.jobsite_multi_search':
          if (location.search) {
            return <JobsiteMultiSearch />
          }
          return <JobsiteMultiSearchForm />
        case 'osr.jobsite_report':
          return <OSRJobsiteReport />
        case 'fwcontracts.letter_search':
          if (location.search) {
            return <LetterSearch />
          } else {
            return <LetterSearchForm />
          }
        case 'reports.activity':
          if (location.search) {
            return <CalendarActivityReport location={location} />
          } else {
            return <CalendarActivityReportForm />
          }
        case 'osr.osr_chart':
          if (location.search) {
            return <OSRReport location={location} />
          }
          return <OSRReportForm />
        case 'njcal.calendar_report':
          if (location.search) {
            return <CalendarReport reportGroup="NY" />
          }
          return <CalendarReport reportGroup="NJ" />
        case 'njcal.copy_link':
          return <CopyLink location={location} />
        case 'tkcal.new_calendar_item':
          return <NewCalendarReportForm />
        case 'fwinvoice.plaintiff_selection':
          if (location.search) {
            return <PlaintiffSearch location={location} />
          }
          return <PlaintiffSearchForm />
        case 'shb.exclude':
          return <ExclusionProcedure />
        case 'exclusionStatus':
          return <ExclusionStatus />
        case 'timekeeper.send_reports':
          return <EmailTimekeeperReport />
        case 'timekeeper.upload':
          return <UploadTimekeeperFile />
        case 'njasbestos.service_rider':
          return <ServiceRider location={location} />
        case 'upload.upload_form':
          return <UploadCurrencyFile />
        case 'search.cross_entity_search':
          return <CrossEntityReportForm location={location} />
        case 'search.fwc_view':
          return <CrossEntityObject location={location} />
        case 'reports.case_management':
          if (location.search) {
            return <CaseManagementReport location={location} />
          }
          return <CaseManagementReportForm />
        case 'reports.claim_activity':
          if (location.search) {
            return <HistoricalClaimActivityReport location={location} />
          }
          return <HistoricalClaimActivityReportForm />
        case 'get.search':
        case 'ge.search':
        case 'bpd.search':
          if (location.search) {
            return <SingleFieldSearch location={location} />
          }
          return <SingleFieldSearchForm location={location} />
        case 'ledes_upload.invoice_upload_form':
          return <UploadLedesFile />
        case 'upload.invoice_upload_form':
          return <h3>no longer being used</h3>
        case 'bossci.case_selection':
          if (location.search) {
            return <CaseSearch location={location} />
          }
          return <CaseSearchForm />
        case 'reports.master_case_list':
          return <MasterCaseList />
        case 'reports.active_case_full_report':
          return <ActiveCasesPDF location={location} />
        case 'reports.retrievex':
          if (location.search) {
            return <RetrievexReport location={location} />
          }
          return <RetrievexForm />
        case 'quarterly_audit.report':
        case 'quarterly_audit_new.report':
          if (location.search && !location.search.includes('oldInputs')) {
            return <QuarterlyAuditReport location={location} />
          }
          return <QuarterlyAuditReportForm location={location} />
        case 'case_query.case_query_report':
          if (location.search) {
            return <CaseCourtSurgeryReport location={location} />
          }
          return <CaseCourtSurgeryReportForm location={location} />
        case 'defense_fees.report':
          if (location.search) {
            return <PaidDefenseIndemnityFees location={location} />
          }
          return <PaidDefenseIndemnityFeesForm />
        case 'liberty.settlement':
          if (location.search && !location.search.includes('in_use_date_assigned')) {
            return <PaidIndemnity />
          }
          return <PaidIndemnityForm />
        case 'medicare_new.report':
          if (location.search && !location.search.includes('in_use_date_assigned')) {
            return <MedicareNew location={location} />
          }
          return <MedicareNewForm />
        case 'audit_report.audit_report':
          if (location.search) {
            return <AuditReport location={location} />
          }
          return <AuditReportForm />
        case 'audit_report.report_pdf':
          return <AuditReportPdf location={location} />
        case 'period_based_report.period_based_report':
          if (location.search) {
            return <PeriodBasedReport location={location} />
          }
          return <PeriodBasedReportForm />
        case 'period_based_details':
          return <PeriodBasedDetails location={location} />
        case 'liberty_mutual.liberty_mutual_month_rep':
          if (location.search.includes('in_report_type')) {
            return <LibertyMutualDefenseFeesForm location={location} />
          }
          return <LibertyMutualDefenseFees location={location} />
        case 'liberty_mutual_2024.liberty_mutual_month_rep':
          if (location.search.includes('in_report_type')) {
            return <LibertyMutual2024Form location={location} />
          }
          return <LibertyMutual2024 location={location} />
        case 'aig.aig_report':
        case 'aig2.aig_report':
          return location.search ? <AIGReport /> : <AIGReportForm />
        case 'trial.trial_date_report':
          if (location.search) {
            return <TrialDateReport location={location} />
          }
          return <TrialDateForm />
        case 'trial.calendar':
          if (location.search) {
            return <TrialCalendarReport location={location} />
          }
          return <TrialCalendarForm />
        case 'loss_settlement.loss_settlement_list_report':
        case 'forcast.loss_settlement_list_report':
          if (location.search && !location.search.includes('in_forcast')) {
            return <LossSettlementReport location={location} />
          }
          return <LossSettlementForm location={location} />
        case 'duplicate.duplicate_ssn_report':
          return <DuplicateSSNReport location={location} />
        case 'reports.stat_pit_rep':
          if (location.search) {
            return <ClaimCountsTodayReport location={location} />
          }
          return <ClaimCountsTodayForm />
        case 'damages_sought.damages_sought_report':
          if (location.search) {
            return <DamagesSoughtReport location={location} />
          }
          return <DamagesSoughtForm />
        case 'work_history.upload_form':
          return <WorkHistoryUpdate />
        case 'plaintiff_firm.claimant_report':
          if (location.search) {
            return <PlaintiffFirmReport location={location} />
          }
          return <PlaintiffFirmReportForm />
        case 'duplicates.duplicates':
          if (location.search) {
            return <DuplicatePlaintiffReport location={location} />
          }
          return <DuplicatePlaintiffReportForm />
        case 'product_surgery.report':
          if (location.search) {
            return <ProductSurgeryReport location={location} />
          }
          return <ProductSurgeryReportForm />
        case 'activity.calendar':
          if (location.search) {
            return <AsbestosCalendarActivityReport location={location} />
          }
          return <AsbestosCalendarActivityReportForm />
        case 'reopened.reopened_claims_report':
          if (location.search) {
            return <ReopenedClaimsReport location={location} />
          }
          return <ReopenedClaimsReportForm />
        case 'internal_loss_settlement.report':
          if (location.search) {
            return <LossSettlementFundingRequestReport location={location} />
          }
          return <LossSettlementFundingRequestForm />
        case 'LossSettlementFundingRequestPDF':
          return <LossSettlementFundingRequestPDF location={location} />
        case 'reports.work_history':
          if (location.search) {
            return <WorkHistoryReport location={location} />
          }
          return <WorkHistoryReportForm />
        case 'logs.log_report':
          if (location.search && !location.search.includes('in_type')) {
            return <LogReport location={location} />
          }
          return <LogReportForm location={location} />
        case 'reports.valuation_projection':
          if (location.search) {
            return <ValuationProjectionReport location={location} />
          }
          return <ValuationProjectionForm />
        case 'reports.category_valuation_projection':
          return <ValuationProjectionByCategory location={location} />
        case 'reports.open_claims_by_attorney':
          return <OpenClaimsByAttorneyPDF />
        case 'reports.bordereaux':
          if (location.search) {
            return <BordereauxReportDetails location={location} />
          }
          return <BordereauxReportPDF />
        case 'case_count.summary':
          let byFirm = location.search.includes('BY_FIRM') ? 'BY_FIRM' : ''
          location.search = `?inputs={"level":"SUMMARY", "byFirm":"${byFirm}"}`
          return <CaseCountWeekReport location={location} />
        case 'caseCountDetails':
          return <CaseCountWeekDetails location={location} />
        case 'claim_count_by_state.report':
          return <ClaimCountsByStateForm />
        case 'claim_count.claim_count_by_disease':
          const inPlaintiff = location.search.includes('PLAINTIFF') ? true : false
          return <ClaimCountsByDiseaseForm inPlaintiff={inPlaintiff} />
        case 'claim_count_by_report':
          console.log(location.search)
          const params = new URLSearchParams(location.search)
          let reportType = params.get('reportType')
          return <ClaimCountsByReport location={location} reportType={reportType} />
        case 'exclude.count_change':
          return <ExclusionCountChangesReport />
        case 'fw.plaintiff_update':
          if (location.search) {
            return <PlaintiffUpdate location={location} />
          }
          return <PlaintiffUpdateForm />
        case 'risk_summary.claim_counts':
          return <RiskSummaryReport />
        case 'cost.average_cost  ':
        case 'cost.average_cost':
          if (location.search) {
            return <AverageDefenseCost location={location} />
          }
          return <AverageDefenseCostForm />
        case 'plaintiff.defense_fee_report':
          if (location.search) {
            return <PlaintiffDefenseFeeReport location={location} />
          }
          return <PlaintiffDefenseFeeForm />
        case 'medicare.medicare_revised':
          if (location.search) {
            return <MedicareReport location={location} />
          }
          return <MedicareReportForm />
        case 'segal.claim_file_export':
          if (location.search) {
            return <ClaimFileReport location={location} />
          }
          return <ClaimFileForm />
        case 'external_legal_cost.report':
          if (location.search) {
            return <CostReport location={location} />
          }
          return <CostReportForm />
        case 'plaintiff.list_invoices':
          return <ListInvoices location={location} />
        case 'reports.invoice_detail_rep':
          if (location.search) {
            return <InvoiceDetailReport location={location} />
          }
          return <InvoiceDetailForm />
        case 'monthly_count.report':
          if (location.search) {
            return <MonthlyCountReport location={location} />
          }
          return <MonthlyCountForm />
        case 'njasbestos.deposition_report':
          if (location.search) {
            return <DepositionReport location={location} />
          }
          return <DepositionReportForm />
        case 'data_quality.count_report':
          return <DataQualityReport location={location} />
        case 'data_quality.detail':
          return <DataQualityDetail location={location} />
        case 'reports.summaries':
          return <QuarterlySummaryReport />
        case 'reports.all_by_month_year':
          return <PendingByReport title={'ALL TENDER REJECTED CASES BY MONTH AND YEAR'} procedureName={'all_by_month_year'} />
        case 'document_controller.state_matrix':
          return <Workflow location={location} />
        case 'bossci.show_circular':
          return <CircularReferences />
        case 'mrg.tickler_report':
          return <TicklerReport />
        case 'mrg.plaintiff_update':
          if (location.search) {
            return <AAGPlaintiffUpdate location={location} />
          }
          return <AAGPlaintiffUpdateForm />
        case 'mrg.plaintiff_report':
          if (location.search) {
            return <PlaintiffReport location={location} />
          }
          return <PlaintiffReportForm />
        case 'admin_tools.create_picklist':
          if (location.search) {
            return <PicklistResults location={location} />
          }
          return <PicklistForm location={location}/>
        case 'document_view.display_audit_log':
          return <ActivityLogRoute location={location} match={match} />
        case 'billedHours':
          if (location.search) {
            return <BilledHoursReport />
          }
          return <BilledHoursReportForm location={location}/>
        case 'showSignUpLink':
          return <ShowSignUpLink />
        default:
      }
    }
  }
  return (
    <h3 style={{ marginTop: '20px', textAlign: 'center' }}>
      The custom code for this route has not yet been implemented: {procedure}
    </h3>
  )
}
